import { api } from "../helper/apiClient.js";

function getSession() {
  try {
    const raw = sessionStorage.getItem("user");
    const user = raw ? JSON.parse(raw) : null;
    return {
      condominio: user?.condominio ?? null,
      token: user?.token ?? null,
      user,
    };
  } catch {
    return { condominio: null, token: null, user: null };
  }
}

export default async function getCondominios() {
  const { token } = getSession();
  if (!token) {
    return { ok: false, status: 0, error: "Sessão inválida: token ausente" };
  }
  const res = await api("/condominios", { method: "GET", token });
  if (!res.ok || !res.data) {
    console.error("Erro ao carregar condomínios:", res.error || "Resposta inválida");
    return { ok: false, status: res.status, error: res.error || "invalid_response", data: { condominios: null } };
  }
  const lista = res.data.condominios ?? res.data.urls ?? null;

  if (!Array.isArray(lista)) {
    console.error("Resposta sem lista de condomínios válida.");
    return { ok: false, status: res.status ?? 200, error: "invalid_response", data: { condominios: null } };
  }

  return { ok: true, status: res.status ?? 200, data: { condominios: lista } };
}

export async function criarCondo(payload){
  const { token } = getSession();
  if (!token) {
    return { ok: false, status: 0, error: "Sessão inválida: token ausente" };
  }
  if (!payload || typeof payload !== "object") {
    return { ok: false, status: 0, error: "Payload inválido" };
  }

  const res = await api("/condominios", { 
    method: "POST", 
    token, 
    body: payload
  });
  
  if (!res.ok) {
    console.error("Erro ao criar condomínio:", res.error);
    return {
      ok: false,
      status: res.status,
      error: res.error || "create_failed",
      data: null,
    };
  }

  return {
    ok: true,
    status: res.status ?? 201,
    data: res.data ?? null,
  };
}

export async function atualizarCondo(id, payload) {
  const { token } = getSession();
  if (!token) {
    return { ok: false, status: 0, error: "Sessão inválida: token ausente" };
  }
  if (!id) {
    return { ok: false, status: 0, error: "Parâmetro 'id' é obrigatório" };
  }
  if (!payload || typeof payload !== "object") {
    return { ok: false, status: 0, error: "Payload inválido" };
  }

  const res = await api(`/condominios/${id}`, {
    method: "PUT",
    token,
    body: payload,
  });

  if (!res.ok) {
    console.error("Erro ao atualizar condomínio:", res.error);
    return {
      ok: false,
      status: res.status,
      error: res.error || "update_failed",
      data: null,
    };
  }

  return {
    ok: true,
    status: res.status ?? 200,
    data: res.data ?? null,
  };
}

export async function deletarCondo(id){
  const { token } = getSession();
  if (!token) {
    return { ok: false, status: 0, error: "Sessão inválida: token ausente" };
  }
  if (!id) {
    return { ok: false, status: 0, error: "Parâmetro 'id' é obrigatório" };
  }

  const res = await api(`/condominios/${id}`, {
    method: "DELETE",
    token,
  });

  if (!res.ok) {
    console.error("Erro ao deletar condomínio:", res.error);
    return {
      ok: false,
      status: res.status,
      error: res.error || "delete_failed",
      data: null,
    };
  }

  return {
    ok: true,
    status: res.status ?? 200,
    data: res.data ?? null,
  };
}

export async function getCondominioById(id) {
  const { token } = getSession();
  if (!token) return { ok: false, status: 0, error: "Sessão inválida: token ausente" };
  if (!id) return { ok: false, status: 0, error: "Parâmetro 'id' é obrigatório" };

  return api(`/condominios/${id}`, { method: "GET", token });
}

export async function atualizarCacheCondo(payload) {
  const { token } = getSession();
  if (!token) return { ok: false, status: 0, error: "Sessão inválida: token ausente" };
  if (!payload || typeof payload !== "object") return { ok: false, status: 0, error: "Payload inválido" };

  return api("/condominios/chamados/atualizar-cache", { method: "PUT", body: payload, token });
}

export async function atualizarCacheChamado(condominioId) {
  const { token } = getSession();
  if (!token) return { ok: false, status: 0, error: "Sessão inválida: token ausente" };
  if (condominioId === undefined || condominioId === null) {
    return { ok: false, status: 0, error: "Parâmetro 'condominioId' é obrigatório" };
  }

  return api("/condominios/chamados/atualizar-cache", {
    method: "POST",
    body: { condominioId },
    token,
  });
}

export async function listarCondosUrl({ soStrings = true } = {}) {
  const res = await getCondominios();
  if (!res.ok || !Array.isArray(res.data?.condominios)) {
    return { ok: false, status: res.status, error: res.error || "invalid_response", data: [] };
  }
  const urls = res.data.condominios
    .map(c => c?.url)
    .filter(Boolean);

  return {
    data: soStrings ? urls : res.data.condominios.map(c => ({ id: c.id ?? c._id, url: c.url })),
  };
}